import React, { Component } from "react";
// import { Other } from "./Other";
// import Prodi from "./Prodi";
import PT from "./PT";
import SPMI from "./SPMI";


class Dashboard extends Component {
    render() {
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let view = [];
        if(sessiondata.i_idrole === 6 || sessiondata.i_idrole === 3){
            view = <PT/>
        }else{
            view = <SPMI/>
        }
        return (view);
    }
}
export default Dashboard;